// src/DilConnects.jsx
import { dummyDilConnects } from './dummyProfiles';

export default function DilConnects() {
  const connects = dummyDilConnects;

  if (connects.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-center text-gray-500 px-6">
        <div className="text-5xl mb-4">❤️</div>
        <h3 className="text-xl font-semibold mb-2">No Dil Connects yet</h3>
        <p className="text-sm">
          Keep swiping in Discover — your first mutual match will appear here!
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4 mt-6">
      {connects.map((connect) => (
        <div
          key={connect.id}
          className="bg-white rounded-xl shadow-sm overflow-hidden flex items-center gap-4 p-4 hover:shadow-md transition-shadow"
        >
          <div className="relative">
            <img
              src={connect.photo}
              alt={connect.name}
              className="w-16 h-16 rounded-full object-cover border-2 border-pink-100"
            />
            <div className="absolute -bottom-1 -right-1 bg-green-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center border-2 border-white">
              ✓
            </div>
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-semibold text-lg">
                  {connect.name}, {connect.age}
                </h3>
                <p className="text-xs text-gray-500 mt-0.5">
                  Connected {connect.matchedAt}
                </p>
              </div>

              <button className="w-20 bg-pink-400 text-white-400 hover:text-white-800 text-sm font-medium px-3 py-1 rounded-full hover:bg-pink-200 transition-colors">
                Chat
              </button>
            </div>

            <p className="mt-1 text-sm text-gray-700 line-clamp-1">
              {connect.bio}
            </p>

            <div className="mt-2 text-xs">
              {connect.type === "they-requested" ? (
                <span className="text-green-600 font-medium">They reached out first ❤️</span>
              ) : (
                <span className="text-blue-600 font-medium">You made the move 💪</span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}